var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAttachMoneySGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2999 11.4C10.0299 10.81 9.29995 10.2 9.29995 9.25C9.29995 8.16 10.3099 7.4 11.9999 7.4C13.7799 7.4 14.4399 8.25 14.4999 9.5H16.7099C16.6399 7.78 15.5899 6.2 13.4999 5.69V3.5H10.4999V5.66C8.55995 6.08 6.99995 7.34 6.99995 9.27C6.99995 11.58 8.90995 12.73 11.6999 13.4C14.1999 14 14.6999 14.88 14.6999 15.81C14.6999 16.5 14.2099 17.6 11.9999 17.6C9.93995 17.6 9.12995 16.68 9.01995 15.5H6.81995C6.93995 17.69 8.57995 18.92 10.4999 19.33V21.5H13.4999V19.35C15.4499 18.98 16.9999 17.85 16.9999 15.8C16.9999 12.96 14.5699 11.99 12.2999 11.4Z",
    fill: "#008148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttachMoneySGreen);
export default __webpack_public_path__ + "static/media/icon-attach_money-s-green.d1d891eee02dc6026fff2a7d9c27adef.svg";
export { ForwardRef as ReactComponent };